import { useMonth } from '@datepicker-react/hooks';
import Day from './Day';
import arrowLeft from '../../assets/images/arrow-left.svg';
import arrowRight from '../../assets/images/arrow-right.svg';

const Month = ({
  year,
  month,
  firstDayOfWeek,
  goToPreviousMonths,
  goToNextMonths,
  range,
  idx,
  last,
  blockArrows
}) => {
  const formatLabel = wl => {
    return wl
      .toString()
      .trim()
      .split(' ')[0];
  };
  const { days, weekdayLabels, monthLabel } = useMonth({
    year,
    month,
    firstDayOfWeek,
    weekdayLabelFormat: formatLabel
  });
  const showLeft = (range && idx === 0) || !range;
  const showRight = (range && idx === last) || !range;
  return (
    <div className="datepicker-block">
      <div className={`datepicker-nav ${blockArrows && 'justify-content-center'}`}>
        {!blockArrows && (
          <button
            type="button"
            className={`datepicker-nav-button${showLeft ? '' : ' hide-nav'}`}
            onClick={goToPreviousMonths}
          >
            <img src={arrowLeft} alt="arrow" />
          </button>
        )}
        <div className="datepicker-month-title">{monthLabel}</div>
        {!blockArrows && (
          <button
            type="button"
            className={`datepicker-nav-button${showRight ? '' : ' hide-nav'}`}
            onClick={goToNextMonths}
          >
            <img src={arrowRight} alt="arrow" />
          </button>
        )}
      </div>
      <div className="datepicker-week-block">
        {weekdayLabels.map(dayLabel => (
          <div className="datepicker-week-day" style={{ textAlign: 'center' }} key={dayLabel}>
            {dayLabel}
          </div>
        ))}
      </div>
      <div className="datepicker-days-block">
        {days.map((day, index) => (
          // eslint-disable-next-line react/no-array-index-key
          <Day date={day.date} key={`${monthLabel}-${day.dayLabel}-${index}`} day={day.dayLabel} />
        ))}
      </div>
    </div>
  );
};

export default Month;
